import { Button } from '@mui/material'
import { InformationModal } from 'utoniq-ui'

import { useTranslation } from '@/core'

export type ConfirmationRollGachaByPointModalProps = {
  open: boolean
  onClose: () => void
  price: number
  count: number
  gachaRolling: boolean
  onClick: () => void
}
export const ConfirmationRollGachaByPointModal = ({
  open,
  onClose,
  price,
  count,
  gachaRolling,
  onClick,
}: ConfirmationRollGachaByPointModalProps) => {
  const { t } = useTranslation('gachaDetail')

  return (
    <InformationModal
      open={open}
      onClose={onClose}
      title={t('confirmRollGachaByPointTitle')}
      content={t('confirmRollGachaByPointDesc', {
        price,
        number: count,
      })}
      cancelText={t('close')}
      buttons={
        <Button
          size="large"
          sx={{ width: 212 }}
          disabled={gachaRolling}
          loading={gachaRolling}
          onClick={onClick}
        >
          {t('draw')}
        </Button>
      }
    />
  )
}
